import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { ClientSidebar } from "../components/navigation/ClientSidebar";
import { ClientHeader } from "../components/navigation/ClientHeader";
import { useUiStore } from "../stores/ui.store";
import { cn, initColorThemeFromStorage } from "@cliently/ui";



export const ClientLayout = () => {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const { pathname: _pathname } = useLocation();

  useLayoutEffect(() => {
    initColorThemeFromStorage();
  }, []);

  return (
    <div className="flex h-screen overflow-hidden text-sm">
      <a
        href="#main-content"
        className="bg-primary text-primary-foreground sr-only z-50 rounded-md px-3 py-2 focus:not-sr-only focus:absolute focus:left-2 focus:top-2"
      >
        Aller au contenu principal
      </a>
      <ClientSidebar />
      <div
        className={cn(
          "flex flex-1 flex-col overflow-hidden transition-all duration-300",
          sidebarOpen ? "md:ml-64" : "md:ml-16",
        )}
      >
        <ClientHeader />
        <main
          id="main-content"
          tabIndex={-1}
          className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden focus:outline-none"
        >
          <div className="mx-auto w-full min-w-0 max-w-[1280px] px-4 py-4 md:px-6 md:py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
